var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login"},[_c('content-spinner',{attrs:{"show":true,"fullscreen":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }